<template>
  <div
    class="science-card d-flex flex-row justify-content-between h-100 py-2 pl-2"
  >
    <div class="d-flex justify-content-between align-items-start">
      <div
        class="p-0 h-100 d-flex flex-column align-items-stretch justify-content-between"
      >
        <div class="mb-1">
          <div class="title mb-1">
            The science behind your reports
          </div>
          <p class="subtitle align-self-start">
            Curious to know how our process works? Get a sneak-peek here
          </p>
        </div>
        <button
          type="button"
          class="btn w-50 btn-outline-primary"
          @click="openScienceModal"
        >
          View
        </button>
      </div>
    </div>
    <div class="align-self-center d-flex justify-content-end">
      <img
        class="science-card_image"
        src="@/assets/images/science-card.png"
        alt="product image"
      >
    </div>
    <b-modal
      ref="science-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      @hide="hideScienceModal"
    >
      <div class="modal-header">
        <button
          type="button"
          class="close"
          @click="hideScienceModal"
        >
          &times;
        </button>
      </div>
      <h2 class="modal-title text-center">
        The science behind your reports
      </h2>
      <div class="scienceModal">
        <div class="scienceModal_image">
          <img
            v-if="scienceModalPageNo === 1"
            src="@/assets/images/sciencepage1.png"
          >
          <img
            v-if="scienceModalPageNo === 2"
            src="@/assets/images/sciencepage2.png"
          >
          <img
            v-if="scienceModalPageNo === 3"
            src="@/assets/images/sciencepage3.png"
          >
          <img
            v-if="scienceModalPageNo === 4"
            src="@/assets/images/sciencepage4.png"
          >
          <img
            v-if="scienceModalPageNo === 5"
            src="@/assets/images/sciencepage5.png"
          >
          <img
            v-if="scienceModalPageNo === 6"
            src="@/assets/images/sciencepage6.png"
          >
          <img
            v-if="scienceModalPageNo === 7"
            src="@/assets/images/sciencepage7.png"
          >

        </div>
        <div
          v-if="scienceModalPageNo === 1"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>Your saliva sample is used to extract your DNA. Your DNA is your personal genome which is your source code. It holds all the information that your body needs to survive.</p>
        </div>
        <div
          v-if="scienceModalPageNo === 2"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>A microarray or a chip ‘reads’ your DNA sample to generate the unique combinations of letters in your DNA sequence. This helps us study single-letter changes in your DNA code called Single Nucleotide Polymorphisms or SNPs. This is called SNP genotyping. We use SNP chips from Illumina, which is the gold standard in genotyping technology.</p>
        </div>
        <div
          v-if="scienceModalPageNo === 3"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>Your stool sample is used to extract bacterial DNA i.e., the genetic material of the bacteria in your gut. Your gut microbiome is like your second genome, forming a dynamic ecosystem that is central to your health.</p>
        </div>
        <div
          v-if="scienceModalPageNo === 4"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>Using Next Generation Sequencing (NGS) technology from Illumina, we study bacterial DNA sequences to identify the different species of bacteria, their richness and abundance in your gut.</p>
        </div>
        <div
          v-if="scienceModalPageNo === 5"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>Your data is processed by our in-house algorithms which profile biomarkers in your DNA and gut microbiome.</p>
        </div>
        <div
          v-if="scienceModalPageNo === 6"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>We map the dual insights DNA + gut microbiome to our nutrition databases, which have over 500 foods and compounds, to identify your unique dietary requirements.</p>
        </div>
        <div
          v-if="scienceModalPageNo === 7"
          class="m-1 scienceModal_content"
        >
          <h4>Step {{ scienceModalPageNo }}</h4>
          <p>Dietary recommendations best suited to your profile are used for formulating your final recommendations report.</p>
        </div>
        <div class="scienceModal_btns ">
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '1', value: 1}"
            styles="custom-circle-questionnaire-button-2"
          />
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '2', value: 2}"
            styles="custom-circle-questionnaire-button-2"
          />
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '3', value: 3}"
            styles="custom-circle-questionnaire-button-2"
          />
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '4', value: 4}"
            styles="custom-circle-questionnaire-button-2"
          />
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '5', value: 5}"
            styles="custom-circle-questionnaire-button-2"
          />
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '6', value: 6}"
            styles="custom-circle-questionnaire-button-2"
          />
          <circle-questionnaire-button
            v-model.Number="scienceModalPageNo"
            :option="{label: '7', value: 7}"
            styles="custom-circle-questionnaire-button-2"
          />
        </div>

      </div>
    </b-modal>
  </div>
</template>
<script>
import CircleQuestionnaireButton from '@/components/CircleQuestionnaireButton.vue'

export default {
  components: {
    CircleQuestionnaireButton,
  },
  data() {
    return {
      scienceModalPageNo: 1,
    }
  },
  methods: {
    openScienceModal() {
      this.$refs['science-modal'].show()
    },
    hideScienceModal() {
      this.$refs['science-modal'].hide()
      this.scienceModalPageNo = 1
    },
  },
}

</script>
<style lang="scss">
  .science-card {
  border-radius: 10px;
  background-color: white;
  .title {
    color: var(--color-primary-dark);
    padding: 0;
  }

  .subtitle {
    font-size: var(--dashboard-small-font-size);
    color: var(--color-primary-light);
  }
  &_image{
    width: 150px;
    @media (min-width: 789px) {
      width: 200px;
    }
  }
}
.modal .modal-header{
  background-color: white !important;
}
.modal .modal-header .close{
transform: none !important;
}
  .scienceModal{
    display: grid;
    margin: 1rem;
    @media (min-width: 789px){
      grid-template-columns: 1fr 4fr 1fr;
      margin: 3rem;
    }
    &_content{
      align-self: center;
      @media (max-width: 768px) {
        text-align: center;
      }
    }
    &_image{
      @media (max-width: 768px) {
        justify-self: center;
      }
      img{
      height: 200px;
      width: 200px;
      object-fit: scale-down;
      @media (max-width: 1024px){
      height: 150px;
      width: 150px;
    }
    }
    }
    p{
      color: #142B6F;
      @media (max-width: 768px){

      }
    }
    &_btns{
      display: flex;
      justify-content: center;
      @media (min-width: 769px) {
        flex-direction: column;
      }
    }
  }
</style>
